import { render, staticRenderFns } from "./FirmList.vue?vue&type=template&id=6df97c04&scoped=true"
import script from "./FirmList.vue?vue&type=script&lang=js"
export * from "./FirmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df97c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df97c04')) {
      api.createRecord('6df97c04', component.options)
    } else {
      api.reload('6df97c04', component.options)
    }
    module.hot.accept("./FirmList.vue?vue&type=template&id=6df97c04&scoped=true", function () {
      api.rerender('6df97c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setup/firmManager/FirmList.vue"
export default component.exports